import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Orientation } from 'src/app/api/services/presentation.d';
import { PresentationUtilsService } from 'src/app/presentations/services/presentation-utils.service';

@Component({
  selector: 'product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  standalone: false,
})
export class ProductDetailsComponent {
  product;
  orientation: Orientation;
  imageUrl: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<ProductDetailsComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { product: any; orientation?: Orientation },
    private presentationUtils: PresentationUtilsService,
  ) {
    this.product = data.product;
    this.orientation = data.orientation ?? 'landscape';
    this.imageUrl = this.presentationUtils.getProductImageUrl(
      this.product,
      this.orientation,
    );
  }

  select() {
    this.dialogRef.close(this.product);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}
